import React from "react"
import logo from "./logo.svg"

export default () => 
<div>
    <div className="text-center">
        <h1 className="mb-12"><img className="inline-block" src={logo} alt="Social Buzz - Exmouth" /></h1>
    </div>
</div>